import React, { useCallback, useLayoutEffect, useState } from "react";
import clsx from "clsx";
import { createStyles, makeStyles } from "@material-ui/core";
import { useIdleTimer } from "react-idle-timer";
import { useLiveChatConfig } from "../../NavProvider";
import { clickOnChatLink } from "../analytics";
import ChatBubble from "./ChatBubble";
var useStyles = makeStyles(createStyles({
    "@keyframes shrink": {
        from: {
            maxWidth: 150,
        },
        to: {
            maxWidth: 48,
        },
    },
    "@keyframes hideText": {
        from: {
            color: "#fff",
        },
        to: {
            color: "transparent",
        },
    },
    button: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        width: "auto",
        height: 48,
        padding: 12,
        backgroundColor: "#333",
        borderRadius: 24,
    },
    shrinked: {
        maxWidth: 48,
    },
    shrinkAnimation: {
        animation: "$shrink .4s ease",
    },
    helpText: {
        minWidth: "max-content",
        marginLeft: 8,
        fontSize: 14,
        fontWeight: "bold",
        color: "#fff",
    },
    helpTextHidden: {
        color: "transparent",
    },
    helpTextAnimation: {
        animation: "$hideText .4s ease",
    },
}));
var LiveChatButton = function (_a) {
    var whatsAppUrl = _a.whatsAppUrl;
    var styles = useStyles();
    var _b = useLiveChatConfig(), scrollLengthToAppearBubbleInPixels = _b.scrollLengthToAppearBubbleInPixels, idleTimeToShowBubble = _b.idleTimeToShowBubble, needHelp = _b.needHelp, whatsAppImage = _b.whatsAppImage;
    var _c = useState({ state: window.pageYOffset > 0, animation: false }), shrink = _c[0], setShrink = _c[1];
    var _d = useState(false), isIdle = _d[0], setIsIdle = _d[1];
    var handleIdle = useCallback(function () {
        if (window.pageYOffset > scrollLengthToAppearBubbleInPixels)
            setIsIdle(true);
    }, [scrollLengthToAppearBubbleInPixels]);
    var resetIdleTimer = useIdleTimer({
        element: document,
        debounce: 250,
        timeout: idleTimeToShowBubble * 1000,
        onIdle: handleIdle,
    }).reset;
    var handleCollapseAnimationEnd = useCallback(function () {
        resetIdleTimer();
    }, [resetIdleTimer]);
    useLayoutEffect(function () {
        var scrollHandler = function () {
            if (window.pageYOffset > 0)
                requestAnimationFrame(function () {
                    setShrink(function (_a) {
                        var prevState = _a.state;
                        return ({
                            state: true,
                            animation: !prevState,
                        });
                    });
                    setIsIdle(false);
                });
        };
        window.addEventListener("scroll", scrollHandler, { once: true });
        return function () {
            window.removeEventListener("scroll", scrollHandler);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { className: clsx(styles.button, shrink.state && styles.shrinked, shrink.animation && styles.shrinkAnimation), id: "acm-livechat__button", href: whatsAppUrl, target: "_blank", rel: "noopener noreferrer", onClick: function () { return clickOnChatLink(whatsAppUrl); }, onAnimationEnd: handleCollapseAnimationEnd },
            React.createElement("img", { id: "acm-livechat__icon", src: whatsAppImage, alt: "WhatsApp", width: 24, height: 24, loading: "lazy" }),
            React.createElement("span", { id: "acm-livechat__help-text", className: clsx(styles.helpText, shrink.state && styles.helpTextHidden, shrink.animation && styles.helpTextAnimation) }, needHelp)),
        React.createElement(ChatBubble, { whatsAppUrl: whatsAppUrl, show: isIdle && shrink.state })));
};
export default LiveChatButton;
